import VatDefinition from "@/views/info/vat_definition.vue";
import VatBenefit from "@/views/info/vat_benefit.vue";
import VatCondition from "@/views/info/vat_condition.vue";
import VatCondition2 from "@/views/info/vat_condition2.vue";
import RegisterProcess from "@/views/info/register_process.vue";
import VatCalculation from "@/views/info/vat_calculation.vue";
import GoodsTax from "@/views/info/goods_tax.vue";
import Documents from "@/views/info/documents.vue";
import DocumentsCorp from "@/views/info/documents_corp.vue";
import Penalty from "@/views/info/penalty";
import PenaltyFull from "@/views/info/penalty_full";
import PersonTypeDefinition from "@/views/info/person_type_definition.vue";
import WithholdingTaxDefinition from "@/views/info/withholding_tax_definition";
import CorpVatDefinition from "@/views/info/corp_vat_definition.vue";
import CorpSuggestion from "@/views/info/corp_suggestion";
import ExpenseTypeDefinition from "@/views/info/expense_type_definition";
import FineDetail from "@/views/info/fine_detail";
import ProsCons from "@/views/info/pros_cons";
import ChangeProcess from "@/views/info/change_process";
import Faqs from "@/views/info/faqs";

export default [
  {
    path: "/info/vat_definition",
    name: "InfoVatDefinition",
    component: VatDefinition,
  },
  {
    path: "/info/vat_benefit",
    name: "InfoVatBenefit",
    component: VatBenefit,
  },
  {
    path: "/info/documents",
    name: "InfoDocuments",
    component: Documents,
  },
  {
    path: "/info/documents_corp",
    name: "InfoDocumentsCorp",
    component: DocumentsCorp,
  },
  {
    path: "/info/person_type_definition",
    name: "InfoPersonTypeDefinition",
    component: PersonTypeDefinition,
    props: { prevPath: "/questions/person_type" },
  },
  {
    path: "/info/vat_calculation",
    name: "InfoVatCalculation",
    component: VatCalculation,
  },
  {
    path: "/info/vat_condition",
    name: "InfoVatCondition",
    component: VatCondition,
    props: { prevPath: "/info/vat_definition" },
  },
  {
    path: "/info/vat_condition_2",
    name: "InfoVatCondition2",
    component: VatCondition2,
    props: { prevPath: "/info/vat_condition" },
  },
  {
    path: "/info/register_process",
    name: "InfoRegisterProcess",
    component: RegisterProcess,
    props: { prevPath: "/info/vat_condition_2" },
  },
  {
    path: "/info/goods_tax",
    name: "InfoGoodsTax",
    component: GoodsTax,
  },
  {
    path: "/info/corp_vat_definition",
    name: "InfoCorpVatDefinition",
    component: CorpVatDefinition,
  },
  {
    path: "/info/corp_suggestion",
    name: "InfoCorpSuggestion",
    component: CorpSuggestion,
  },
  {
    path: "/info/penalty",
    name: "InfoPenalty",
    component: Penalty,
  },
  {
    path: "/info/penalty_full",
    name: "InfoPenaltyFull",
    component: PenaltyFull,
  },
  {
    path: "/info/withholding_tax_definition",
    name: "WithholdingTaxDefinition",
    component: WithholdingTaxDefinition,
    props: { prevPath: "/summaries/corp_goods_with_vat" },
  },
  {
    path: "/info/expense_type_definition",
    name: "ExpenseTypeDefinition",
    component: ExpenseTypeDefinition,
  },
  {
    path: "/info/fine_detail",
    name: "FineDetail",
    component: FineDetail,
  },
  {
    path: "/info/pros_cons",
    name: "ProsCons",
    component: ProsCons,
  },
  {
    path: "/info/change_process",
    name: "ChangeProcess",
    component: ChangeProcess,
  },
  {
    path: "/info/faqs",
    name: "Faqs",
    component: Faqs,
  },
];
